import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import userSlice from './slices/userSlice';
import productSlice from './slices/productSlice';
import messageSlice from './slices/messageSlice';
import documentSlice from './slices/documentSlice';
import rfqSlice from './slices/rfqSlice';
import quoteSlice from './slices/quoteSlice';
import orderSlice from './slices/orderSlice';
import adminSlice from './slices/adminSlice';
import conversationsSlice from './slices/conversationsSlice';
import supportMessagesSlice from './slices/messagesSlice';
import searchSlice from './slices/searchSlice';
import toastSlice from './slices/toastSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userSlice,
    products: productSlice,
    messages: messageSlice,
    documents: documentSlice,
    rfqs: rfqSlice,
    quotes: quoteSlice,
    orders: orderSlice,
    admin: adminSlice,
    search: searchSlice,
  toasts: toastSlice,
  conversations: conversationsSlice,
  supportMessages: supportMessagesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;